// Turns a Google Places address string (what sellers pick on the location step)
// into a label that is safe to show publicly on a listing card.
//
// The stored address can be a full street address, so this never returns a
// street or suburb. It returns "<STATE>, Australia" for Australian addresses,
// the country for everything else, and null when there is nothing safe to show.

const AU_STATE_PATTERN = /\b(VIC|NSW|QLD|WA|SA|TAS|ACT|NT)\b/;

export const getLocationLabel = address => {
  if (typeof address !== 'string') {
    return null;
  }

  const parts = address
    .split(',')
    .map(part => part.trim())
    .filter(Boolean);

  // A single part has no country to show, and could itself be a street or suburb
  if (parts.length < 2) {
    return null;
  }

  // Google addresses end with the country name; anything containing digits is not one
  const country = parts[parts.length - 1];
  if (/\d/.test(country)) {
    return null;
  }

  if (country.toLowerCase() === 'australia') {
    const stateMatch = parts[parts.length - 2].match(AU_STATE_PATTERN);
    return stateMatch ? `${stateMatch[1]}, Australia` : 'Australia';
  }

  return country;
};
